var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaLogoAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 580 596",
    role: "img",
    "aria-label": "SelficAI logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "aiGlow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 2.5,
    floodColor: "#2563eb",
    floodOpacity: 0.28
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 5,
    floodColor: "#06b6d4",
    floodOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gTLDeep",
    x1: 45,
    y1: 50,
    x2: 330,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b1533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gTLViolet",
    x1: 30,
    y1: 220,
    x2: 336,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b21b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c3aed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gTRCyan",
    x1: 399,
    y1: 54,
    x2: 429,
    y2: 370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bae6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#38bdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0284c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gTRSky",
    x1: 445,
    y1: 40,
    x2: 560,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0f2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ea5e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBRDeep",
    x1: 210,
    y1: 365,
    x2: 503,
    y2: 555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBRTeal",
    x1: 352,
    y1: 446,
    x2: 560,
    y2: 314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d4ed8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#06b6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22d3ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBLIndigo",
    x1: 67,
    y1: 525,
    x2: 178,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3730a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5b4fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBLGlow",
    x1: 157,
    y1: 290,
    x2: 234,
    y2: 530,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4338ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#818cf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67e8f9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gCenter",
    cx: "50%",
    cy: "48%",
    r: "42%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f0f9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e7ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#aiGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 173 C78 57 176 4 250 18 C305 29 334 85 355 158 C281 123 185 117 96 146 C58 158 29 169 5 173 Z",
    fill: "url(#gTLDeep)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 262 C79 157 190 111 308 139 C329 144 348 151 365 160 C286 161 193 173 112 205 C58 227 23 249 0 262 Z",
    fill: "url(#gTLViolet)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 14 C425 14 533 97 565 237 C498 155 429 88 302 14 Z",
    fill: "url(#gTRSky)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383 39 C468 95 506 206 479 291 C459 344 424 366 367 386 C403 302 417 158 383 39 Z",
    fill: "url(#gTRCyan)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 363 C298 431 402 454 491 417 C530 401 557 376 579 320 C572 445 465 554 340 559 C281 562 237 499 226 363 Z",
    fill: "url(#gBRDeep)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 361 C321 452 470 452 579 320 C553 338 515 361 466 379 C379 411 290 406 227 361 Z",
    fill: "url(#gBRTeal)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 211 C104 276 60 355 77 437 C87 489 123 529 162 556 C67 532 7 461 15 380 C23 304 82 244 179 211 Z",
    fill: "url(#gBLIndigo)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 211 C171 299 184 435 244 556 C193 527 154 477 141 421 C128 361 139 290 181 211 Z",
    fill: "url(#gBLGlow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 211 C229 181 286 166 365 160 C333 173 303 190 274 214 C229 252 192 306 177 367 C143 350 120 334 98 314 C116 279 143 244 178 211 Z",
    fill: "url(#gCenter)",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 386 C319 394 268 387 226 361 C214 426 252 513 340 559 C257 535 198 471 179 392 C164 331 174 270 209 220 C260 146 348 99 446 73 C489 111 515 165 526 224 C483 152 415 120 340 143 C256 168 195 236 179 318 C166 379 196 433 244 466 C285 494 347 491 413 463 C459 443 513 406 579 320 C535 399 456 447 367 458 C299 467 238 444 199 403 C212 466 267 520 340 559 C250 543 180 486 153 408 C127 333 147 257 209 197 C255 153 311 132 365 160 C305 183 256 225 222 282 C186 343 190 410 234 456 C279 504 357 498 431 457 C485 427 533 379 579 320 C527 373 464 404 367 386 Z",
    fill: "url(#gCenter)",
    opacity: 0.96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaLogoAi);
export default __webpack_public_path__ + "static/media/sa_logo_ai.d26e3e6054456c772640a1f7a0bb8e06.svg";
export { ForwardRef as ReactComponent };